exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ProgressBar-module__progress-bar___2KjPF{display:grid;grid-template-columns:auto 1fr auto;gap:16px;align-items:center;max-width:400px}.ProgressBar-module__progress-bar___2KjPF .ProgressBar-module__bar___39QMH{height:10px;background-color:#e8f7fc;border-radius:999px}.ProgressBar-module__progress-bar___2KjPF .ProgressBar-module__bar___39QMH .ProgressBar-module__progress___LujLB{width:30%;background-color:#35b6dd;height:100%;border-radius:999px;overflow:hidden}", ""]);

// exports
exports.locals = {
	"progress-bar": "ProgressBar-module__progress-bar___2KjPF",
	"bar": "ProgressBar-module__bar___39QMH",
	"progress": "ProgressBar-module__progress___LujLB"
};